import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=8ec2e8a4&"
import script from "./charge.vue?vue&type=script&lang=js&"
export * from "./charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports